import dayjs from 'dayjs';
import SvgIcon from 'root/components/SvgIcon';
import { GCheckboxCol, GFileCol, GNameCol, GModifiedCol } from '..';
import SVG_ICONS from '~/assets/icons/icons';

const FolderRow = (props) => (
  <div className="FolderRow flex items-center bb bc-source-bg pointer" onClick={props.rowClickHandler}>
    <GCheckboxCol>
      <label />
    </GCheckboxCol>
    <GFileCol>
      <SvgIcon size="xl2" path={SVG_ICONS.FOLDER} colorName="menu-icons" />
    </GFileCol>
    <GNameCol>{props.item.name}</GNameCol>
    <GModifiedCol className="nowrap">{dayjs(props.item.client_modified).format('MMMM D, YYYY')}</GModifiedCol>
  </div>
);

export default FolderRow;
